<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";


import TargetTrainingHoursForm from "../../../components/training/targettraininghours/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": TargetTrainingHoursForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('trainingsetup.edittargettraining'),
      pageTitleValue: "",
      formData: {
        startyear: null,
        startmonth: null,
        endyear: null,
        endmonth: null,
        minhours: null,
        trntargetgrpid: null,
        trntargetgrpdesc: null,
        trntargetgrpcode: null,
        //logicscrpt: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    loadTargetTrainingHoursHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/targettraininghours/" + vm.id})
        .then((res) => {

          vm.formData.startyear = res.data.rec[0].startyear;
          vm.formData.startmonth = res.data.rec[0].startmonth;
          vm.formData.endyear = res.data.rec[0].endyear;
          vm.formData.endmonth = res.data.rec[0].endmonth;
          vm.formData.minhours = res.data.rec[0].minhours;
          vm.formData.trntargetgrpid = res.data.rec[0].trntargetgrpid;
          vm.formData.trntargetgrpdesc= res.data.rec[0].trntargetgrpdesc;
          vm.formData.trntargetgrpcode = res.data.rec[0].trntargetgrpcode;
        //  vm.formData.lockstaff = res.data.rec[0].lockstaff;
          vm.formData.stamp = res.data.rec[0].stamp;

        //  console.log('trntargetgrpcode', vm.formData.trntargetgrpcode)
          
          vm.pageTitleValue = res.data.rec[0].trntargetgrpdesc;
          vm.loading = false;

        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      //var payload = this.formData[0];

      this.$store.dispatch('put', {url: "/targettraininghours/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "targettraininghourslist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    // cancelHandler() {
    //   this.$router.push({ name: "rdayscheduleinstructionlist" });
    // },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

         this.$store.dispatch('delete', {url:
            "/targettraininghours/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "targettraininghourslist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "targettraininghoursnew" });
    },
  },

  async mounted() {
    await this.loadTargetTrainingHoursHandler();
  },
};
</script>